import { create } from 'zustand';
import { WfUser } from '../models/WfUser';

export type WfUserStoreState = {
  users: WfUser[];
  user: WfUser | null;
  selectedUser: WfUser | null;
  isAdmin: boolean;
  setIsAdmin: (isAdmin: boolean) => void;
  setUsers: (users: WfUser[]) => void;
  setUser: (user: WfUser | null) => void;
  setSelectedUser: (selectedUser: WfUser | null) => void;
};

export const useWfUserStore = create<WfUserStoreState>((set) => ({
  users: [],
  user: null,
  selectedUser: null,
  isAdmin: false,
  setIsAdmin: (isAdmin: boolean) => set({ isAdmin }),
  setUsers: (users: WfUser[]) => {
    set({ users });
  },
  setUser: (user) => {
    set({ user });
  },
  setSelectedUser: (selectedUser) => {
    set({ selectedUser });
  },
}));
